<script>
export default {
  name: 'SectionCard',
  props: {
    sectionId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <!-- scroll-mt-[72px]: a jump lands just under the ~59px sticky section bar
       (ProjectDetail.vue). transition-shadow fades the ring ProjectDetail
       adds briefly to the section a jump lands on. -->
  <section
    :id="`sec-${sectionId}`"
    class="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-5 scroll-mt-[72px] transition-shadow duration-700"
  >
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-base font-semibold text-slate-900 dark:text-slate-100">
        {{ title }}
      </h2>
      <slot name="action" />
    </div>
    <slot />
  </section>
</template>
